<template>
  <public-page>
    <div class="relaxtion-protocol">
      <relaxation-protocol-background-card />
      <relaxation-protocol-card />
    </div>
  </public-page>
</template>

<script>
import PublicPage from './PublicPage'
import RelaxationProtocolBackgroundCard from '../cards/RelaxationProtocolBackgroundCard'
import RelaxationProtocolCard from '../cards/RelaxationProtocolCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'relaxtion-protocol',
  components: {
    PublicPage,
    RelaxationProtocolBackgroundCard,
    RelaxationProtocolCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/relaxation-protocol',
      ogTitle: 'Relaxation Protocol - Rewarding Dog Training',
      ogDescription: 'Mobile-friendly version of Dr. Karen Overall\'s Protocol for Relaxation with checkboxes to track progress as you go through it.',
    })
  },
}
</script>

<style lang="scss">
</style>
